import { createSelector } from 'reselect';
import { TYPE_MULTIPLE_CHOICE } from '../views/questions/reducers/questions';

const getQuestions = state => state.questions;

// @todo update to new structure
export const hasQuestions = createSelector(
    [getQuestions],
    (state) => {
        if (Object.keys(state.events).length === 0 && state.orders.length === 0) {
            return false;
        }

        return true;
    }
)

export const getAnswers = createSelector(
    [getQuestions],
    (state) => {
        let answers = [];
        let questions = getAllQuestions(state);

        for(let i = 0; i < questions.length; i++) {
            let answer = questions[i].answer;
            if (questions[i]?.question_type == TYPE_MULTIPLE_CHOICE) {
                const selectedOptions = answerInSelectMultipleFormat(answer) ? [...answer.selectedOptions] : [];
                if (!!answer?.writeIn) {
                    selectedOptions.push(answer.writeIn);
                }
                answer = selectedOptions;
            }
            answers.push({
                answer: answer,
                question_id: questions[i].resource_id,
                resource_id: questions[i].answer_resource_id,
                resource_type: getResourceType(questions[i].answer_resource_type)
            })
        }

        return answers;
    }
)

export const isQuestionComplete = createSelector(
    [getQuestions],
    (state) => {
        let questions = getAllQuestions(state);
        for(let i = 0; i < questions.length; i++) {
            if(questions[i].required === "1" && questions[i].answer === "") {
                return false;
            }
        }

        return true;
    }
)

function getAllQuestions(questionState) {
    let questions = [];

    questions = questions.concat(questionState.orders);

    for (const id in questionState.events) {
        questions = questions.concat(questionState.events[id].questions);
        for (const ticketId in questionState.events[id].ticketQuestions) {
            questions = questions.concat(questionState.events[id].ticketQuestions[ticketId]);
        }
    }

    return questions;
}

function getResourceType(type) {
    if(type === "Sale") {
        return "reservation";
    }

    return type.toLowerCase();
}

export const defaultSelectMultipleAnswer = () => {
    return {
        selectedOptions: [],
        writeIn: '',
    };
}

export const answerInSelectMultipleFormat = answer => {
    return Array.isArray(answer?.selectedOptions);
}
